import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Input } from '@node-space/ui-components'
import { AddBeneficiaryFormErrors, BaseFormProps } from 'types/beneficiaries'

interface BeneficiaryAddressFieldsProps extends BaseFormProps {
  isOptional?: boolean
  addressLine1: string
  addressLine2: string
  city: string
  errors: AddBeneficiaryFormErrors
  postCode: string
  region: string
}

export const BeneficiaryAddressFields = ({
  isOptional,
  addressLine1,
  addressLine2,
  city,
  errors,
  postCode,
  region,
  handleChange,
  register,
}: BeneficiaryAddressFieldsProps) => {
  const { t } = useTranslation()

  const labels = {
    addressLine1: isOptional ? `${t('addressLine1')} (${t('optional')})` : t('addressLine1'),
    addressLine2: t('addressLine2'),
    city: isOptional ? `${t('city')} (${t('optional')})` : t('city'),
    postCode: isOptional ? `${t('postCode')} (${t('optional')})` : t('postCode'),
    region: isOptional ? `${t('region')} (${t('optional')})` : t('region'),
  }

  return (
    <Box flexCol flexSize="fill">
      <Box flexCol width="full" gapX={12} paddingB={16}>
        <Input
          {...register('addressLine1')}
          label={labels?.addressLine1}
          inputMode="text"
          name="addressLine1"
          test-id="input-address-line-1"
          errorText={errors?.addressLine1?.message}
          error={!!errors?.addressLine1}
          value={addressLine1}
          onChange={event => handleChange('addressLine1', event?.target?.value)}
          placeholder={t('inputPlaceholders.enterAddressLine1Placeholder')}
        />
      </Box>
      <Box flexCol width="full" gapX={12} paddingB={16}>
        <Input
          {...register('addressLine2')}
          label={labels?.addressLine2}
          inputMode="text"
          name="addressLine2"
          test-id="input-address-line-2"
          errorText={errors?.addressLine2?.message}
          error={!!errors?.addressLine2}
          value={addressLine2}
          onChange={event => handleChange('addressLine2', event?.target?.value)}
          placeholder={t('inputPlaceholders.enterAddressLine2Placeholder')}
        />
      </Box>
      <Box flex gapX={12} paddingB={16}>
        <Box flexSize="auto" width="full">
          <Input
            {...register('city')}
            label={labels?.city}
            inputMode="text"
            name="city"
            test-id="input-city"
            errorText={errors?.city?.message}
            error={!!errors?.city}
            value={city}
            onChange={event => handleChange('city', event?.target?.value)}
            placeholder={t('inputPlaceholders.enterCityPlaceholder')}
          />
        </Box>
        <Box flexSize="auto" width="full">
          <Input
            {...register('postCode')}
            label={labels?.postCode}
            inputMode="text"
            name="postCode"
            test-id="input-post-code"
            errorText={decodeURI(encodeURI(errors?.postCode?.message))}
            error={!!errors?.postCode}
            value={postCode}
            onChange={event => handleChange('postCode', event?.target?.value)}
            placeholder={t('inputPlaceholders.enterPostalCodePlaceholder')}
          />
        </Box>
      </Box>
      <Box flexCol width="full" paddingB={16}>
        <Input
          {...register('region')}
          label={labels?.region}
          inputMode="text"
          name="region"
          test-id="input-region"
          errorText={decodeURI(encodeURI(errors?.region?.message))}
          error={!!errors?.region}
          value={region}
          onChange={event => handleChange('region', event?.target?.value)}
          placeholder={t('inputPlaceholders.enterRegionPlaceholder')}
          width={'full'}
        />
      </Box>
    </Box>
  )
}
